<template>
    <div>
        <div class="legacy-content-frame">
            <render-component class="component-content" :component="component" :data="enrollment.data" @saveData="saveData" v-if="!loading && component"/>
            <div class="content" v-else>
                <h3 class="has-text-grey"><i class="fas fa-spinner fa-spin mr-4"></i>Please wait. Loading content...</h3>
            </div>
        </div>
        <div class="content-controls">

            <div class="columns" v-if="component.type === 'QUIZ'">
                <div class="column is-8">
                    <div v-if="quizGraded && !loading">
                        <div class="is-size-6 ml-1">
                            You got <strong>{{quizResults.correct}}</strong> of <strong>{{quizResults.questions}}</strong> questions correct for a score of <strong>{{Math.ceil(quizResults.score * 100)}}%</strong>.

                            <div v-if="outline.quiz_min_score && Math.ceil(quizResults.score * 100) < outline.quiz_min_score">
                                You must achieve a score of <strong>{{outline.quiz_min_score}}</strong>% to continue.  Please retry the assessment.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column has-text-right">
                    <div v-if="quizGraded">
                        <div v-if="outline.quiz_min_score && Math.ceil(quizResults.score * 100) < outline.quiz_min_score">
                            <b-button type="is-white" outlined @click="retryQuiz()" class="ml-5">Retry Assessment<i class="fas fa-undo ml-3"></i></b-button>
                        </div>
                        <div v-else>
                            <b-button type="is-white" outlined @click="completeComponent()" class="ml-5" v-if="!loading && !outline.completed_at">Complete<i class="fas fa-check ml-3"></i></b-button>
                            <b-button type="is-white" outlined v-if="!loading && outline.completed_at && prevOutlineId" @click="goToOutline(prevOutlineId)"><i class="fas fa-arrow-left mr-3"></i>Previous</b-button>
                            <b-button type="is-white" outlined class="ml-5" v-if="!loading && outline.completed_at && nextOutlineId" @click="goToOutline(nextOutlineId)">Next<i class="fas fa-arrow-right ml-3"></i></b-button>
                        </div>
                    </div>
                    <div v-else>
                        <b-button type="is-white" outlined @click="gradeQuiz()" v-if="!loading" class="ml-5">Grade Assessment<i class="fas fa-list-check ml-3"></i></b-button>
                    </div>
                </div>
            </div>
            <div class="columns" v-else>
                <div class="column" v-if="!loading & !enrollment.completed_at">
                    <div>
                        <b-tooltip position="is-right" type="is-white" class=" mr-4">
                            <template v-slot:content>
                                <i class="fas fa-check mr-1"></i>Data automatically saved to the cloud.
                            </template>
                            <i class="fad fa-cloud-check fa-lg"></i>
                        </b-tooltip>
                        <i class="fas fa-circle fa-xs mr-2" style="color: red;"></i>
                        <strong>Recording Time:</strong> {{formattedLessonTime}}<span v-if="outline.require_min_time"> of {{formattedMinTime}} required.</span>
                    </div>
                </div>
                <div class="column has-text-right">
                    <b-button type="is-white" outlined v-if="!loading && prevOutlineId" @click="goToOutline(prevOutlineId)"><i class="fas fa-arrow-left mr-3"></i>Previous</b-button>
                    <b-button type="is-white" outlined class="ml-5" v-if="!loading && outline.completed_at && nextOutlineId" @click="goToOutline(nextOutlineId)">Next<i class="fas fa-arrow-right ml-3"></i></b-button>
                    <b-button type="is-white" outlined @click="completeComponent()" class="ml-5" v-if="!loading && !outline.completed_at">Complete<i class="fas fa-check ml-3"></i></b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {v4 as uuidv4} from 'uuid';
    import moment from "moment";
    import async from "async";

    import {client as http} from "@/http_client";
    import RenderComponent from "../../components/RenderComponent";

    export default {
        components: {RenderComponent},
        props: ['enrollmentId', 'outlineId'],
        data: function() {
            return {
                loading: true,
                component: {},
                enrollment: {
                    data: {}
                },
                outline: {},
                prevOutlineId: null,
                nextOutlineId: null,
                quizGraded: false,
                timer: null,
                time: 0,
                uuid: null,
                timeout: 60
            };
        },
        computed: {
            formattedTime: function() {
                return moment.utc(this.time * 1000).format('HH:mm:ss');
            },
            formattedMinTime: function() {
                return moment.utc(this.outline.require_min_time * 60 * 1000).format('HH:mm:ss');
            },
            formattedLessonTime: function() {
                return moment.utc((this.time * 1000) + (this.outline.time * 60 * 1000)).format('HH:mm:ss');
            },
            quizResults: function() {
                let results = {
                    questions: 0,
                    answered: 0,
                    correct: 0,
                    incorrect: 0
                };
                let data = this.component.content;
                for (let i = 0; i < data.blocks.length; i++) {
                    const block = data.blocks[i];
                    if (block.type === 'quizMultiple') {
                        results.questions++
                        if (this.enrollment.data[block.data.id]) {
                            results.answered++;
                            if (this.enrollment.data[block.data.id].correct) {
                                results.correct++;
                            } else {
                                results.incorrect++;
                            }
                        }
                    }
                }
                results.score = results.correct/results.questions;
                return results;
            }
        },
        methods: {
            loadByOutline: function() {
                if (this.timer) clearInterval(this.timer);
                this.time = 0;
                this.uuid = uuidv4();
                this.loading = true;

                this.quizGraded = false;
                this.timeout = 60;

                async.series([
                    (cb) => {
                        http.get('app/enrollments/' + this.enrollmentId, {force: true}).then(response => {
                            this.enrollment = response.data;

                            for (let i = 0; i < this.enrollment.course.outline.length; i++) {
                                let o = this.enrollment.course.outline[i];
                                if (o.id === parseInt(this.outlineId)) {
                                    this.outline = o;
                                    this.nextOutlineId = (this.enrollment.course.outline[i+1]) ? this.enrollment.course.outline[i+1].id : null;
                                    break;
                                } else if (o.type === 'COMPONENT') {
                                    this.prevOutlineId = o.id;
                                }
                            }
                            cb();
                        }).catch(err => {
                            console.log('Enrollment loading failed.');
                            cb(err);
                        });
                    },
                    (cb) => {
                        http.get('app/components/' + this.outline.type_id).then(response => {
                            if (response.data.type === 'QUIZ') {
                                response.data.content = JSON.parse(response.data.content);
                                for (let i = 0; i < response.data.content.blocks.length; i++) {
                                    const block = response.data.content.blocks[i];
                                    if (block.type === 'quizMultiple') {
                                        block.data.graded = false;
                                        block.data.reveal = false;
                                    }
                                }
                            }
                            this.component = response.data;
                            cb();
                        }).catch(err => {
                            console.log(err);
                            cb(err);
                        });
                    }
                ], (err) => {
                    if (err) console.log(err);

                    if (this.component.type === 'QUIZ' && this.outline.completed_at) {
                        console.log('Marking quiz complete');
                        this.quizGraded = true;
                        this.gradeQuiz();
                    }

                    if (!this.enrollment.completed_at) {
                        this.startTimer();
                        this.sendPing();
                    }

                    this.loading = false;
                });
            },

            gradeQuiz: function() {
                this.quizGraded = false;
                if (this.quizResults.questions !== this.quizResults.answered) {
                    window.alert('Please answer all questions first.');
                } else {
                    let data = this.component.content;
                    for (let i = 0; i < data.blocks.length; i++) {
                        const block = data.blocks[i];
                        if (block.type === 'quizMultiple') {
                            if (this.enrollment.data[block.data.id] && this.enrollment.data[block.data.id].correct) {
                                // correct
                                block.data.graded = 'correct';
                                block.data.reveal = true;
                            } else {
                                // incorrect
                                block.data.graded = 'incorrect';
                                if (this.outline.quiz_min_score >= (this.quizResults.score * 100)) {
                                    // passed quiz
                                    block.data.reveal = (this.outline.quiz_pass_reveal === 1);
                                } else {
                                    // failed quiz
                                    block.data.reveal = (this.outline.quiz_fail_reveal === 1);
                                }
                            }
                        }
                    }
                    this.quizGraded = true;
                }
            },

            retryQuiz: function() {
                let data = this.component.content;

                for (let i = 0; i < data.blocks.length; i++) {
                    const block = data.blocks[i];
                    if (block.type === 'quizMultiple') {
                        block.data.graded = false;
                        block.data.reveal = false;

                        if (this.outline) {}
                        if (this.outline.quiz_retry_correct && this.enrollment.data[block.data.id].correct) this.enrollment.data[block.data.id] = null;
                        if (this.outline.quiz_retry_incorrect && !this.enrollment.data[block.data.id].correct) this.enrollment.data[block.data.id] = null;
                    }
                }
                this.quizGraded = false;
            },

            saveData: function(payload) {
                payload.enrollment_id = parseInt(this.enrollmentId);
                http.post('/app/enrollments/save', payload, {force: true}).then(response => {

                }).catch(err => {

                });
            },

            startTimer: function() {
                console.log('Timer: starting');
                this.timer = setInterval(() => {
                    // Idle auto-timeout: stop accruing/pinging while idle, then leave
                    if (this.isAppIdle) {
                        this.timeout--;
                        this.timeout = Math.max(0, this.timeout);
                        if (this.timeout === 0) {
                            console.log('timeout');
                            clearInterval(this.timer);
                            // Exit just the lesson viewer, back to the legacy course screen
                            this.$router.push({name: 'legacy', params: {enrollmentId: this.$route.params.enrollmentId}});
                        }
                        return;
                    }
                    this.time++;
                    if (this.time % 60 === 0) this.sendPing();
                }, 1000);
            },

            sendPing: function() {
                let payload = {
                    session_id: this.uuid,
                    time: this.time,
                    component_id: this.component.id,
                    course_id: this.enrollment.course_id,
                    enrollment_id: this.enrollment.id,
                    type: 'course_outline',
                    type_id: this.outline.id
                };

                http.post('/app/enrollments/ping', payload, {force: true}).then(response => {

                }).catch(err => {

                });
            },

            completeComponent: function() {
                if (this.outline.require_min_time && Math.floor(this.time/60 + this.outline.time <= this.outline.require_min_time)) {
                    window.alert('You have not completed the required time for this lesson.  Please review the content.')
                } else {
                    this.$emit('loading', true);

                    let payload = {
                        component_id: this.component.id,
                        enrollment_id: this.enrollment.id,
                        type: 'course_outline',
                        type_id: this.outline.id
                    };

                    http.post('/app/enrollments/progress', payload, {force: true}).then(response => {
                        this.$emit('update');

                        if (this.nextOutlineId) {
                            this.$router.push({name: 'legacy-component', params: {enrollmentId: this.enrollmentId, outlineId: this.nextOutlineId}});
                        } else {
                            this.$router.push({name: 'legacy', params: {enrollmentId: this.enrollmentId}});
                        }
                    }).catch(err => {
                        if (err.response?.status === 423) {
                            // Milestone lock (paused pending reflection approval) — surface
                            // the backend's actual reason instead of a generic message.
                            window.alert(err.response.data.error || 'This course is paused pending approval of a milestone reflection.');
                        } else {
                            window.alert('There was an issue completing the course content. If this problem persists please contact us.');
                        }
                        this.$emit('loading', false);
                    });
                }
            },
            goToOutline: function(id) {
                this.prevOutlineId = null;
                this.nextOutlineId = null;
                this.$router.push({name: 'legacy-component', params: {enrollmentId: this.enrollmentId, outlineId: id}});
            }
        },
        watch: {
            'outlineId': function() {
                this.loadByOutline();
            }
        },
        mounted: function() {
            this.loadByOutline();
        },
        destroyed: function() {
            if (this.timer) clearInterval(this.timer);
        },
        onIdle() {
            console.log('IDLE');
            this.timeout = 60;
        },
        onActive() {
            console.log('ACTIVE');
            this.timeout = 60; // reset grace; do NOT ping (would back-count the idle gap)
        }
    };
</script>

<style lang="scss" scoped>
    .legacy-content-frame {
        position: absolute;
        top: 105px;
        left: var(--course-frame-left);
        right: var(--course-frame-right);
        bottom: 7rem;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
        padding: 2rem;

        overflow-x: hidden;
        overflow-y: scroll;
    }

    .content-controls {
        position: absolute;
        left: var(--course-frame-left);
        right: var(--course-frame-right);
        bottom: 1.5rem;
        padding: 3rem 0 1rem;
        font-size: 0.85rem;

        color: white;

        strong {
            color: white;
        }
    }
</style>
